class CustomLiquidPerItem extends HTMLElement {
  constructor() {
    super();
  }

  variantIdChangedUnsubscriber = undefined;

  connectedCallback() {
    this.variantIdChangedUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
      (event) => {
        console.log(event.data.html);
        this.innerHTML = event.data.html.getElementById(this.id).innerHTML
      }
    );
  }

  disconnectedCallback() {
    if (this.variantIdChangedUnsubscriber) {
      this.variantIdChangedUnsubscriber();
    }
  }
}


customElements.define('custom-liquid-per-item', CustomLiquidPerItem)